import { FormProvider, useForm } from 'react-hook-form'
import { useDealership } from '../../store/zustand/dealershipStore'
import { useAddCentroCredentials } from '../../api/auth/useAddCentroCredentials'
import toast from 'react-hot-toast'
import React from 'react'
import { Button, TextInput } from '@demandlocal/components'
import { useModal } from '../../components/useModal'
import { useAddBrevoCredentials } from '../../api/auth/useAddBrevoCredentials'
import { queryClient } from '../../api/queryClient'

type FormValues = {
  api_key: string
}

export default function ConnectBrevoForm(): JSX.Element {
  const { closeModal } = useModal()
  const formContext = useForm<FormValues>({
    mode: 'onSubmit',
  })
  const dealership = useDealership()
  const { mutateAsync: saveBrevoCredentials, isLoading } = useAddBrevoCredentials()
  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = formContext

  const onSubmit = async (values: FormValues): Promise<void> => {
    const toastId = toast.loading('Saving Brevo Credentials')
    await saveBrevoCredentials(
      {
        api_key: values.api_key,
      },
      {
        onError: (err) => {
          toast.error('Error Saving Brevo Credentials', { id: toastId })
          throw err
        },
      },
    )
    await queryClient.refetchQueries([dealership?.organization_id, 'linked-accounts'])
    toast.success('Centro Credentials Saved', { id: toastId })
    reset({
      api_key: '',
    })
    closeModal()
  }
  return (
    <FormProvider {...formContext}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={'flex flex-1 flex-col px-12 pt-12 font-Spartan h-full'}>
        <div className={'flex flex-1 flex-col overflow-auto'}>
          <div className={'flex gap-4'}>
            <span className={'font-bold text-[28px] text-primary-xiketic'}>
              Connect Brevo
            </span>
          </div>
          <div className={'pt-6 pb-6 flex flex-col'}>
            <div className={'flex flex-col gap-8 w-full'}>
              <div className={'w-1/2'}>
                <TextInput
                  inverted={true}
                  disabled={isSubmitting}
                  name={'api_key'}
                  label={'Api Key'}
                  placeholder={'xkeysib-XXXXXXXXXXXXX'}
                  info={`You can find your API key in your Brevo account under Settings > SMTP & API > API Keys`}
                />
              </div>
            </div>
          </div>
        </div>

        <div className={'h-20 items-center flex justify-between border-t-2 py-4 mt-4'}>
          <Button
            variant={'secondary'}
            onClick={(e) => {
              e.preventDefault()
              closeModal()
            }}>
            Close
          </Button>
          <Button disabled={isSubmitting} type={'submit'}>
            Save changes
          </Button>
        </div>
      </form>
    </FormProvider>
  )
}
